'use client'

import React, { FC, ReactElement } from 'react'
import useLoggedIn from '@/utils/hooks/useLoggedIn'

import HeaderProfile from '@/components/header-profile'
import NotificationsBell from '@/components/notifications-bell'
import TopUpNavLink from '@/components/top-up-nav-link'
import ButtonGradientEpic from '@/components/button-gradient-epic'
import { ThemeToggleIcon } from '@/components/ui/theme-toggle'

import event from '@/utils/event'

const HeaderRight: FC = (): ReactElement => {
	const loggedIn = useLoggedIn()

	const handleConnectWallet = React.useCallback((evt: any) => {
		evt.stopPropagation()
		evt.preventDefault()
		event.emit('command', { id: 'connect-wallet' })
	}, [])

	return (
		<div className="flex shrink-0 items-center gap-3 xl:gap-6">
			<div className="flex items-center gap-1">
				<ThemeToggleIcon />
			</div>
			{/* Buy/Sell BTC CTA — navigates to the /markets/bitcoin page
			    instead of popping the MoonPay modal. */}
			<TopUpNavLink className="!h-8 !w-[136px] !px-3 !py-1.5 shrink-0 justify-center bg-chrome-muted !text-xs [&_span]:!text-xs text-foreground hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring" />
			{loggedIn ? (
				<div className="flex items-center gap-2">
					<NotificationsBell />
					<HeaderProfile showCharacterCount={4} />
				</div>
			) : (
				<ButtonGradientEpic
					size="small"
					className="!h-8 !w-[136px] !px-3 !py-1.5 inline-flex items-center justify-center whitespace-nowrap"
					onClick={handleConnectWallet}
				>
					Connect Wallet
				</ButtonGradientEpic>
			)}
		</div>
	)
}

export default HeaderRight
